import React from 'react';

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

/* tslint:disable */
const d =
  'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z';
/* tslint:enable */

export const ErrorIcon = (props: Props) => {
  const { className } = props;
  const size = props.size || 24;
  const color = props.color || '#fff';

  const style = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <svg
      className={className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path fill={color} d={d} />
    </svg>
  );
};
